export default __webpack_public_path__ + "static/Lilly3-da8b9f365fc0cbb08a1b00a716212b11.jpg";